var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-address-picker',_vm._b({attrs:{"url":_vm.terytUrl,"street-search-any":true,"set-city-as-street":false,"street-list-on-city-select":true},on:{"update":function($event){return _vm.$emit('update')}}},'w-address-picker',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }